<template>
  <div class="hero">
    <div class="content">
      <img
        alt="Logo Ouro Fácil"
        src="@/assets/logoouro.png"
        class="brand-logo"
      />

      <div>
        <h1>
          VENDA SEU OURO DE FORMA SIMPLES E SEGURA - <br />
          <span> PAGAMENTO RÁPIDO E GARANTIDO!</span>
        </h1>

        <p>
          Solicite frete grátis e receba o pagamento em 24 horas! Uma transação
          privada que é segura, sem riscos e fácil de fazer.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SiteHeroDefault",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
      default: "",
    },
  },
}
</script>

<style scoped>
.hero {
  background-image: url("@/assets/bg-3.jpeg");
  color: var(--background-color);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;

  margin-bottom: -0px;

  min-height: 80vh;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  h1 {
    max-width: 780px;
    font-size: 25px;
  }
}

.video {
  width: 100%;
  max-width: 750px;
  height: 420px;
  background-color: #3d3227;
  border: 1px solid #695a4b;

  margin-bottom: 64px;
}

.brand-logo {
  max-width: 100%;
  object-fit: contain;
  max-width: 160px;
}

span {
  color: var(--primary-color);
  font-family: "Manrope", sans-serif;
}

p {
  max-width: 700px;

  margin-top: 0;
  font-family: Manrope;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
}

@media only screen and (max-width: 1367px) {
  .hero {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    margin-bottom: -120px;

    .content {
      max-width: 570px;

      .brand-logo {
        max-width: 100%;
        object-fit: contain;
        max-width: 150px;
      }

      h1 {
        font-size: 24px;
      }

      p {
        max-width: 680px;

        margin-top: 0;
        font-family: Manrope;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}

@media only screen and (max-width: 720px) {
  .hero {
    width: 100%;
    padding: 30px;

    background-image: url("@/assets/bg-3-mobile.jpeg");

    height: 83vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: -14px;

    .content {
      .brand-logo {
        max-width: 130px;
      }
      h1 {
        font-size: 20px;
        margin: 20px 0;
      }

      p {
        font-family: Manrope;
        font-size: 15px;
        font-weight: 400;
        line-height: 19px;
        text-align: center;
      }
    }
  }

  .video {
    max-width: 370px;
    max-height: 208px;
  }
}
</style>
